import editCC from '@brands/Dashboard/Sidenav/Icons/Vector.svg';
import React, { useEffect, useState } from 'react';

import { CaseType, ICase } from '../../../../services/cases/types/ICase';
import { updatePaymentAvailability } from '../../../../Utils/getFriendlyName';
import styles from '../appointments.module.scss';

interface Props {
  appointment: ICase;
  setCase: (value: React.SetStateAction<ICase | undefined>) => void;
  setEditCreditCardModal: (value: React.SetStateAction<boolean>) => void;
  updatePaymentAvailabilityCheck: boolean;
}

const EditCreditCardButton = ({
  appointment,
  setCase,
  setEditCreditCardModal,
  updatePaymentAvailabilityCheck,
}: Props): JSX.Element => {
  const [updatePaymentAvailabilityFlag, setUpdatePaymentAvailabilityFlag] = useState(updatePaymentAvailabilityCheck);

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    if (
      (appointment.type === 'video_call_scheduled' || appointment.type === CaseType.phone_call_scheduled) &&
      appointment.video_conference_date &&
      updatePaymentAvailabilityFlag
    ) {
      intervalId = setInterval(() => {
        const dueDate = updatePaymentAvailability(appointment);
        setUpdatePaymentAvailabilityFlag(!!dueDate);
      }, 10000);
    }
    return () => clearInterval(intervalId);
  }, [appointment]);
  return (
    <span>
      {updatePaymentAvailabilityFlag && (
        <button
          type="button"
          className={`fs-unmask ${styles.cancelBtn}`}
          onClick={() => {
            setCase(appointment);
            setEditCreditCardModal(true);
          }}
        >
          <img src={editCC} style={{ width: '21px', marginRight: '6px', marginLeft: '2px' }} />
          Credit Card
        </button>
      )}
    </span>
  );
};

export default EditCreditCardButton;
